module.exports = __webpack_public_path__ + "static/media/authBackground.42087791.png";